export const sentimentLanguageCodes = ['en', 'da', 'sv', 'no']

export const getIsSentimentAvailable = (languageCode: string): boolean => sentimentLanguageCodes.includes(languageCode)
